import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Emit, Component } from 'vue-property-decorator';
import cookies from 'js-cookie';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const COOKIE_POLICY_ACCEPTED = "cookie-policy-accepted";
let CookiePopupNotificationComponent = class extends Mixins(MagicConfigMixin) {
  cookiesAccepted() {
    cookies.set(COOKIE_POLICY_ACCEPTED, "true", { expires: 365 });
  }
};
__decorateClass([
  Emit("close")
], CookiePopupNotificationComponent.prototype, "cookiesAccepted", 1);
CookiePopupNotificationComponent = __decorateClass([
  Component({ name: "cookie-popup-notification" })
], CookiePopupNotificationComponent);

export default CookiePopupNotificationComponent;
